import React from 'react'
import classes from "./Second.module.scss"
import img1 from "../../../assets/img/costcall/2/1.png";
import img2 from "../../../assets/img/costcall/2/2.png";

const Second = () => {
    return (
        <div className={[classes.second, "pt pb"].join(" ")}>
            <div className={[classes.secondBody, ""].join(" ")}>
                <div className="container">
                    <div className={[classes.secondRow, ""].join(" ")}>
                        <div className={[classes.secondRowLeft, ""].join(" ")}>
                            <div className={[classes.secondRowLeftTitle, "font-40"].join(" ")}>
                                Bomber VPN — <span>ваш надёжный союзник</span> в интернете
                            </div>
                            <div className={[classes.secondRowLeftDecor, "decor"].join(" ")}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className={[classes.secondRowLeftText, "font-22"].join(" ")}>
                                Откройте мир безграничных возможностей с VPN-сервисом. Защитите свои данные и личную жизнь в интернете благодаря надёжному шифрованию. Обходите географические ограничения и получите доступ к любимым сайтам и сервисам, где бы вы ни находились.
                            </div>
                            <div className={[classes.secondRowLeftBottom, ""].join(" ")}>
                                <img src={img2} alt="" />
                                <span>Скройте ваш IP-адрес и оставайтесь анонимными в сети. Наслаждайтесь безопасностью и свободой в интернете благодаря VPN</span>
                            </div>
                        </div>
                        <div className={[classes.secondRowRight, ""].join(" ")}>
                            <img src={img1} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Second